<template>
  <ContainerElement :fluid="fluid">
    <component
      :is="component"
      :id="`c${id}`"
      :class="marginClasses"
      :type="type"
      :links="links"
      :meta="meta"
      :attributes="attributes"
      :relationships="relationships"
      v-bind="$attrs"
      v-on="$listeners"
    ></component>
  </ContainerElement>
</template>

<script>
import { getContentElementType } from '@/js/helper/content-element-helper.js'

import ContainerElement from '@/js/components/Shared/ContainerElement.vue'

import components from './components'

// Todo: Entscheiden ob wir die margin classes hier oder in den jeweiligen componenten nutzen
import MarginClassesMixin from '@/js/mixins/margin-classes-mixin.js'
import ElementPropsMixin from '@/js/mixins/element-props-mixin.js'

export default {
  name: 'ContentElement',
  components: {
    ...components,
    ContainerElement,
  },
  mixins: [MarginClassesMixin, ElementPropsMixin],
  data() {
    return {
      componentType: getContentElementType(this.type),
    }
  },
  computed: {
    component() {
      return this.componentType in components ? this.componentType : 'FallbackElement'
    },
  },
}
</script>
